module.exports = __webpack_public_path__ + "760bd83ee04dff470e0277f3eb7deebe.svg";